export const MAIN_INTEGRATIONS = [
    {
        name: 'The Trade Desk',
        helpUrl:
            'https://4d-silverbulletcloud.atlassian.net/wiki/spaces/4DKB/pages/2646081537/4D+Custom+contexts+in+The+Trade+Desk',
    },
    {
        name: 'Google Display & Video 360',
        helpUrl:
            'https://4d-silverbulletcloud.atlassian.net/wiki/spaces/4DKB/pages/2134114314/DV360+-+How+to+Activate+4D+in+Display+Video+360',
    },
    {
        name: 'Amazon Ads',
        helpUrl: 'https://advertising.amazon.com/help/G2PNWH8UWF2PVVGN',
    },
];
export const MAIN_INTEGRATION_NAMES = MAIN_INTEGRATIONS.map(({ name }) => name);

// TODO: filter integrations API side instead of white-listing them here
export const OTHER_INTEGRATION_NAMES = [
    'Adform',
    'Yahoo',
    'Quantcast',
    'Adobe Display',
    'Xandr Deals',
    'MediaMath',
    'OneTag',
    'Nexxen',
];

export const HELP_EMAIL = 'helpme@weare4d.com';
